"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PatternGLPipeline = void 0;

var _PatternSixFoldReflectedGLFilter = _interopRequireDefault(require("./filters/PatternSixFoldReflectedGLFilter"));

var _PatternSquareGLFilter = _interopRequireDefault(require("./filters/PatternSquareGLFilter"));

var _PatternFourFoldReflectedGLFilter = _interopRequireDefault(require("./filters/PatternFourFoldReflectedGLFilter"));

var _PatternEightFoldReflectedGLFilter = _interopRequireDefault(require("./filters/PatternEightFoldReflectedGLFilter"));

var _PatternTwelveFoldReflectedGLFilter = _interopRequireDefault(require("./filters/PatternTwelveFoldReflectedGLFilter"));

var _PatternSixFoldRotatedGLFilter = _interopRequireDefault(require("./filters/PatternSixFoldRotatedGLFilter"));

var _glCore = require("@capture/gl-core");

var _PatternTypes = require("./PatternTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class PatternGLPipeline extends _glCore.GLFilterPipeline {
  constructor() {
    const filterNode = new _glCore.GLHorizontalFilterNode([new _PatternSquareGLFilter.default(), new _PatternSixFoldReflectedGLFilter.default(), new _PatternSixFoldRotatedGLFilter.default(), new _PatternFourFoldReflectedGLFilter.default(), new _PatternEightFoldReflectedGLFilter.default(), new _PatternTwelveFoldReflectedGLFilter.default()], parseInt(_PatternTypes.PatternTypes.SixFoldReflectedFilter));
    const cropRotateFilter = new _glCore.GLSquareCropRotateFilter();
    super([cropRotateFilter, filterNode]);
    this.cropRotateFilter = cropRotateFilter;
    this.filterNode = filterNode;
  }

  setPatternType(type) {
    this.filterNode.setSelected(parseInt(type));
  }

  setColorMode(mode) {
    switch (mode) {
      case _PatternTypes.PatternColorModes.Colors:
        this.filterNode.filters.forEach(filter => filter.greyScaleEnabled = false);
        break;

      case _PatternTypes.PatternColorModes.GreyScale:
        this.filterNode.filters.forEach(filter => filter.greyScaleEnabled = true);
    }
  }

  setScale(value) {
    this.cropRotateFilter.setScale(value);
  }

  getScale() {
    return this.cropRotateFilter.getScale();
  }

  setOffset(value) {
    this.cropRotateFilter.setOffset(value);
  }

  getOffset() {
    return this.cropRotateFilter.getOffset();
  }

  setRotation(value) {
    this.cropRotateFilter.setRotation(value);
  }

  getRotation() {
    return this.cropRotateFilter.getRotation();
  }

  setSelectedFilterNode(filter) {
    this.filterNode.setSelected(filter);
  }

  getSelectedFilterNode() {
    return this.filterNode.getSelectedIndex();
  }

  getFilterNode() {
    return this.filterNode;
  }

  drawOffScreen(gl, texture, viewWidth, viewHeight, textureWidth, textureHeight) {
    if (viewWidth !== 640 && viewHeight !== 640) {
      var result = null;
      const filter = this.filterNode.getSelectedFilter();

      if (filter) {
        filter.isGeneratingTile = true;
        filter.zoom = String(this.filterNode.getSelectedIndex()) === _PatternTypes.PatternTypes.EightFoldReflectedFilter ? 1.414 : 1.0;
        result = super.drawOffScreen(gl, texture, viewWidth, viewHeight, textureWidth, textureHeight);
        filter.zoom = 4.0;
        filter.isGeneratingTile = false;
      }

      return result;
    } else {
      const shouldFlip = String(this.filterNode.getSelectedIndex()) === _PatternTypes.PatternTypes.SquareFilter;

      return super.drawOffScreen(gl, texture, viewWidth, viewHeight, textureWidth, textureHeight, shouldFlip);
    }
  }

  process(imageURL, tile = true) {
    const selectedIndex = this.filterNode.getSelectedIndex();
    let outputWidth = tile ? 2048.0 : 640.0;
    let outputHeight = tile ? 2048.0 : 640.0;

    if (tile) {
      switch (String(selectedIndex)) {
        case _PatternTypes.PatternTypes.TwelveFoldReflectedFilter:
        case _PatternTypes.PatternTypes.SixFoldReflectedFilter:
        case _PatternTypes.PatternTypes.SixFoldRotatedFilter:
          outputWidth = Math.round(outputWidth * (3.0 / 4.0) * (2.0 / Math.sin(Math.PI / 3.0) + 2.0 / Math.tan(Math.PI / 3.0)) / 2.0);
          outputHeight = outputHeight * (3.0 / 4.0);
          break;
      }
    }

    return super.process(imageURL, outputWidth, outputHeight);
  }

}

exports.PatternGLPipeline = PatternGLPipeline;

var _default = new PatternGLPipeline();

exports.default = _default;